import React, { FC } from 'react';
import { Connect, PropsFromRedux } from './FolderListContainer';
import { Folder } from '../folders.types';
import styles from './folder_list.module.scss';

type Props = PropsFromRedux & {
  docId: string;
  children: (folder: Folder) => React.ReactNode;
};

export const RawFolderList: FC<Props> = ({ folders, children }) => (
  <>
    {folders.map((folder: Folder) => (
      <div
        className={styles.container}
        key={folder.folderKey}
        data-test-id="folder-in-page"
      >
        {children(folder)}
      </div>
    ))}
  </>
);

export const FolderList = Connect(RawFolderList);
